export default __webpack_public_path__ + "static/og_team-5f0b84911e962d8b2fc26c85bf3432a4.png";